module.exports = __webpack_public_path__ + "static/media/poa-poster-2012.7ea35fb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/POAPoster/poa-poster-2012.png
// module id = 178
// module chunks = 0